/*
  İndirim kodu CTA'sındaki "Kodu Kopyala" butonu.

  Dinleyici doküman düzeyinde tek sefer bağlanır; bölüm sayfada birden fazla
  kez bulunsa bile kopyalama bir kez çalışır. Buton yalnızca bir kolaylıktır:
  kod metin olarak da seçilebilir ve asıl yol tek tıkla kodu uygulayan
  bağlantıdır, bu yüzden betik çalışmazsa bir işlev kaybı olmaz.
*/
(function () {
  var RESET_DELAY = 2400;

  /* navigator.clipboard yalnızca güvenli bağlamda ve yeni tarayıcılarda var;
     yoksa gizli bir alan üzerinden eski execCommand yoluna düşülür. */
  function copy(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', 'readonly');
      field.style.position = 'fixed';
      field.style.top = '-1000px';
      document.body.appendChild(field);
      field.select();

      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }
      document.body.removeChild(field);
      ok ? resolve() : reject();
    });
  }

  function announce(btn, message) {
    /* Butonun görünen metni değişse de ekran okuyucu bunu kendiliğinden
       bildirmez; bu yüzden ayrı bir canlı bölge kullanılır. */
    var wrap = btn.closest('.promo-cta');
    if (!wrap) return;

    var live = wrap.querySelector('[data-promo-status]');
    if (!live) {
      live = document.createElement('span');
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('data-promo-status', '');
      wrap.appendChild(live);
    }
    live.textContent = message;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-promo-copy]');
    if (!btn) return;

    var code = btn.getAttribute('data-promo-copy');
    var label = btn.querySelector('[data-copy-text]');

    copy(code).then(
      function () {
        if (label) label.textContent = btn.getAttribute('data-copied-label') || 'Kopyalandı';
        btn.classList.add('is-copied');
        announce(btn, code + ' kodu kopyalandı.');

        window.clearTimeout(btn._promoTimer);
        btn._promoTimer = window.setTimeout(function () {
          if (label) label.textContent = btn.getAttribute('data-copy-label') || 'Kodu Kopyala';
          btn.classList.remove('is-copied');
        }, RESET_DELAY);
      },
      function () {
        /* Kopyalama engellendiyse kullanıcı kodu elle seçebilsin diye
           metin seçili hale getirilir. */
        var codeEl = btn.parentNode.querySelector('.promo-cta__code');
        if (codeEl && window.getSelection && document.createRange) {
          var range = document.createRange();
          range.selectNodeContents(codeEl);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        }
        announce(btn, 'Kod kopyalanamadı, elle kopyalayabilirsiniz.');
      }
    );
  });
})();
